import { Uuid } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { getApiBaseUrl } from 'src/modules/config/selectors/getApiBaseUrl';
import { select } from 'typed-redux-saga';

export function* getAssetUrl(id: Uuid): SagaIterator<string> {
  const apiBaseUrl = yield* select(getApiBaseUrl);
  return `${apiBaseUrl}/source/${encodeURIComponent(id)}`;
}
